import React from 'react';
import { Card } from 'components/ui/card';
import { AboutBadge } from '../AboutBadge';

export function SectionEssence() {
  return (
    <section className="bg-white rounded-3xl sm:rounded-[48px] p-4 sm:p-6 md:p-10 m-2 sm:m-4 relative z-[1]">
      <div className="px-0 sm:px-8 md:px-16 lg:px-[100px]">
        <AboutBadge text="Суть проекта SMRhub" />
        <p className="font-normal text-sm sm:text-base leading-relaxed sm:leading-6 mt-3 sm:mt-4">
          «Создание портала для партнёрсĸих взаимоотношений в сфере строительной
          индустрии, в формате «Единого оĸна», все в пару ĸлиĸов".
        </p>
      </div>
    </section>
  );
}
